// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Box,
  ExpandableSection,
  Link,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import CopyableCodeView from '../CopyableCodeView';
import { CLI_PREREQUISITES, cliToolInstallCode } from '../constants';

const CliInstallStep = () => {
  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Prerequisites</h3>
          <ul>
            {CLI_PREREQUISITES.map((prereq) => (
              <li key={prereq.label}>
                {prereq.href ? (
                  <Link external href={prereq.href}>
                    {prereq.label}
                  </Link>
                ) : (
                  prereq.label
                )}
                {prereq.note && ` — ${prereq.note}`}
              </li>
            ))}
          </ul>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <p>
            Run the following command to add the ResourceLens registry and
            install the tool:
          </p>
        </TextContent>
        <CopyableCodeView content={cliToolInstallCode} />
      </Box>
      <ExpandableSection headerText="Additional notes">
        <TextContent>
          <p>
            Run <code>toolbox update resourcelens</code> occasionally to ensure
            you have the most up-to-date version of the tool.
          </p>
        </TextContent>
      </ExpandableSection>
    </SpaceBetween>
  );
};

export default CliInstallStep;
